import { render } from "./BasicTextArea.vue?vue&type=template&id=b4cd7c66"
import script from "./BasicTextArea.vue?vue&type=script&lang=js"
export * from "./BasicTextArea.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__